import { AxiosResponse } from 'axios';
import Api from './api';

const DocumentUploadApi = (
  data: any,
): Promise<AxiosResponse> => {
  const path = `/admin/doc/upload`;
  return Api.getInstance().request.post(
    path,
    data,
    undefined, // No additional path
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (e: any) => {},
    },
  );
};

export default DocumentUploadApi;
